<div class="user-footer" [class.is-compact]="layoutService.isCompact()">
  <div class="user-footer__menu" *ngIf="open() && visibleMenuItems.length">
    <button
      type="button"
      class="user-footer__menu-item"
      *ngFor="let item of visibleMenuItems"
      (click)="pick(item)"
    >
      <i-tabler [name]="item.icon" class="user-footer__menu-icon" />
      <span class="user-footer__menu-label">{{ item.label }}</span>
    </button>
  </div>

  <div class="user-footer__row">
    <button
      type="button"
      class="user-footer__badge"
      [class.is-open]="open()"
      (click)="toggleMenu()"
      aria-label="Konto"
      [pTooltip]="userName()"
      tooltipStyleClass="menu-tooltip-white menu-tooltip-white--btn40"
      tooltipPosition="right"
      [tooltipDisabled]="!layoutService.isCompact()"
    >
      <span class="user-footer__avatar">{{ initials() }}</span>
      <span class="user-footer__name">{{ userName() }}</span>
      <i-tabler name="chevron-down" class="user-footer__chevron" [class.is-rotated]="open()" />
    </button>

    <button
      type="button"
      class="user-footer__help"
      (click)="openNectaManual()"
      aria-label="Hilfe"
      pTooltip="Hilfe"
      tooltipStyleClass="menu-tooltip-white menu-tooltip-white--btn40"
      tooltipPosition="right"
      [tooltipDisabled]="!layoutService.isCompact()"
    >
      <i-tabler name="help" class="user-footer__help-icon" />
    </button>
  </div>
</div>
